import { Box, Text, Flex } from '@chakra-ui/react';
import { useMultiStyleConfig } from '@chakra-ui/system';
import React from 'react';

import { useTableExperimentalContext } from './TableExperimentalContext';
import useTablePagination from './_useTablePagination';

import IconButton from 'atoms/Button/IconButton';
import Select from 'atoms/Select/Select';

const TablePagination = (): React.ReactElement => {
  const tableContext = useTableExperimentalContext();
  const { reactTable, setPagination, pageCount } = tableContext;
  const TableExperimentalTheme = useMultiStyleConfig('TableExperimental', { ...tableContext });
  const { handleSelectChange } = useTablePagination({ setPagination });

  return (
    <Box __css={TableExperimentalTheme.pagination}>
      {pageCount && (
        <Flex alignItems="center">
          <Text fontSize="md">Page</Text>
          <Select
            aria-label="Select page number"
            onChange={handleSelectChange}
            size="sm"
            variant="ghost"
            width="100%"
          />
          <Text fontSize="md" width="100%">
            of {pageCount}
          </Text>
        </Flex>
      )}

      <IconButton
        aria-label="Move to previous page"
        disabled={!reactTable.getCanPreviousPage()}
        onClick={reactTable.previousPage}
        size="sm"
        type="AngleLeft"
        variant="ghost"
      />
      <IconButton
        aria-label="Move to next page"
        disabled={!reactTable.getCanNextPage()}
        onClick={reactTable.nextPage}
        size="sm"
        type="AngleRight"
        variant="ghost"
      />
    </Box>
  );
};
export default TablePagination;
